import { useEventDispatcher } from "@otto-ec/otto-components-utils/use/event-dispatcher";
import { untrack } from "svelte";
import { events, sheet } from "../index.js";
import type { Events } from "../../v1/SheetV1.types.js";
import type { SheetGlobalEvents } from "./event.global.js";
import type { OcSheetV1EventDetailBase, OcSheetV1EventDetailBeforeOpen } from "./event.payload.js";
import type { OcSheetV1EventDefintionAny, OcSheetV1GetEventPayload } from "./event.utils.js";
import { stack } from "../stack/global.svelte.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const dispatchSheetEvent = <E extends OcSheetV1EventDefintionAny>(
  event: E,
  instance: NoInfer<OcSheetV1GetEventPayload<E>["instance"]>,
  payload: Omit<OcSheetV1GetEventPayload<E>, "instance" | "extraData" | "id"> & { id?: string },
): boolean => {
  /*                                                           */
  const dispatchDom = instance ? useEventDispatcher<Events>(instance) : null;

  /*                                                              */
  const detail: OcSheetV1EventDetailBase & OcSheetV1EventDetailBeforeOpen = payload as never;
  const instanceOrNull = instance as HTMLOcSheetV1Element | null;

  detail.instance = instance;
  detail.extraData = instanceOrNull?.extraData ?? null;
  /*                                                                          */
  if (instanceOrNull?.id) detail.id = instanceOrNull?.id;

  /*                                     */
  const apiEvent: keyof SheetGlobalEvents = event[0];
  const domEvent: keyof Events = event[1];

  /*                                    */
  events[apiEvent].dispatch(detail as never);
  const results = [dispatchDom?.(domEvent, detail as never)];

  /*                                                           */
  /*                                                                                                   */
  /*                                                                               */
  const legacy = untrack(() => stack.contentChange) ? event[3] : event[2];

  /*                                     */
  legacy.forEach(([apiAlias, domAlias]) => {
    if (domAlias) results.push(dispatchDom?.(domAlias as never, detail as never));
    if (apiAlias) {
      events[apiAlias as keyof SheetGlobalEvents].dispatch(detail as never);
      (sheet[`${apiAlias}Event` as never] as SheetGlobalEvents[keyof SheetGlobalEvents]).dispatch(
        detail as never,
      );
    }
  });

  /*                                                    */
  return results.filter((r) => typeof r === "boolean").every((result) => result);
};
